import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import styles from "./appointments.module.css";
import basestyles from "../../../shared/styles/basestyles.module.css";
import Input from "../../../shared/components/Input/Input";
import Textarea from "../../../shared/components/Textarea/Textarea";
import Button from "../../../shared/components/Button/Button";
import Header from "../../../shared/components/Header/Header";
import Backicon from "../../../shared/components/Backicon/Backicon";
import DoctorsNearby from "../../../shared/components/DoctorsNearby/DoctorsNearby";
import searchbar from "../../../shared/components/SearchBar/searchbar.module.css";

const initialState = {
  Name: "",
  Age: "",
  Phone: "",
  TypeOfProblemHeSheIsFacing: "",
  HaveTheyBeenDiagnosedWithThisProblemBefore: "",
  MedicationsUsed: "",
  InsuranceType: "",
  InsuranceValidity: "",
  NameError: "",
  AgeError: "",
  PhoneError: "",
  TypeOfProblemHeSheIsFacingError: "",
  HaveTheyBeenDiagnosedWithThisProblemBeforeError: "",
  MedicationsUsedError: "",
  InsuranceTypeError: "",
  InsuranceValidityError: "",
  DoctorSelected: "",
};

class Appointments extends Component {
  state = initialState;

  aptchange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  componentDidMount() {
    if (!localStorage.getItem("patient_appointment")) {
      localStorage.setItem("patient_appointment", JSON.stringify({ data: [] }));
    }
    if (localStorage.getItem("doctor_selected")) {
      let doctor = localStorage.getItem("doctor_selected");
      this.setState({ DoctorSelected: JSON.parse(doctor) });
    }
  }

  validate = () => {
    let NameError = "";
    let AgeError = "";
    let PhoneError = "";
    let TypeOfProblemHeSheIsFacingError = "";
    let HaveTheyBeenDiagnosedWithThisProblemBeforeError = "";
    let MedicationsUsedError = "";
    let InsuranceTypeError = "";
    let InsuranceValidityError = "";

    if (!this.state.Name) {
      NameError = "Name cannot be empty";
    }

    if (!this.state.Age) {
      AgeError = "Age cannot be empty";
    }
    if (!this.state.Phone) {
      PhoneError = "Phone number cannot be empty";
    }
    if (!this.state.TypeOfProblemHeSheIsFacing) {
      TypeOfProblemHeSheIsFacingError = "This field cannot be empty";
    }
    if (!this.state.HaveTheyBeenDiagnosedWithThisProblemBefore) {
      HaveTheyBeenDiagnosedWithThisProblemBeforeError =
        "This field cannot be empty";
    }
    if (!this.state.MedicationsUsed) {
      MedicationsUsedError = "This field cannot be empty";
    }
    if (!this.state.InsuranceType) {
      InsuranceTypeError = "Please select your insurance type";
    }
    if (!this.state.InsuranceValidity) {
      InsuranceValidityError = "Please select your insurance validity ";
    }

    if (
      NameError ||
      AgeError ||
      PhoneError ||
      TypeOfProblemHeSheIsFacingError ||
      HaveTheyBeenDiagnosedWithThisProblemBeforeError ||
      MedicationsUsedError ||
      InsuranceTypeError ||
      InsuranceValidityError
    ) {
      this.setState({
        NameError,
        AgeError,
        PhoneError,
        TypeOfProblemHeSheIsFacingError,
        HaveTheyBeenDiagnosedWithThisProblemBeforeError,
        MedicationsUsedError,
        InsuranceTypeError,
        InsuranceValidityError,
      });
      return false;
    }

    return true;
  };

  onSubmit = (e) => {
    e.preventDefault();
    const isValid = this.validate();
    if (isValid) {
      let existingData = localStorage.getItem("patient_appointment");
      existingData = JSON.parse(existingData);
      existingData.data.push({
        ...this.state,
        ...{ id: existingData.data.length + 1 },
      });
      localStorage.setItem("patient_appointment", JSON.stringify(existingData));
      toast.info("Appointment Scheduled...!", {
        autoClose: 2000,
      });
      // clear form
      this.setState(initialState);
    }
  };

  render() {
    return (
      <>
        <div className={styles.backgroundappoint}>
          <Header name="Appointment" />
          <Backicon
            onClick={() => this.props.history.goBack()}
            style={{
              background:
                "linear-gradient(60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
              color: "white",
            }}
          />

          <div className={basestyles.inputWidth}>
            <div className={styles.docName}>
              {this.state.DoctorSelected && (
                <div className={searchbar.doctorlist}>
                  <DoctorsNearby
                    doctor={{
                      Doctor: this.state.DoctorSelected.Doctor,
                      Speciality: this.state.DoctorSelected.Speciality,
                      Address: this.state.DoctorSelected.Address,
                    }}
                  />
                </div>
              )}
            </div>
            <form>
              <label className={styles.ptName}>Name</label>
              <Input
                placeholder="Name"
                type="text"
                name="Name"
                value={this.state.Name}
                onChange={(e) => this.aptchange(e)}
              />
              <div className={styles.errors}>{this.state.NameError}</div>

              <label className={styles.ptAge}>Age</label>
              <Input
                type="text"
                min="15"
                max="100"
                step="1"
                placeholder="ex: 22"
                name="Age"
                value={this.state.Age}
                onChange={(e) => this.aptchange(e)}
              />
              <div className={styles.errors}>{this.state.AgeError}</div>

              <label className={styles.ptphone}>Phone</label>
              <Input
                type="tel"
                placeholder="1-555-777-6666"
                name="Phone"
                value={this.state.Phone}
                onChange={(e) => this.aptchange(e)}
              />
              <div className={styles.errors}>{this.state.PhoneError}</div>

              <label className={styles.ptprob}>
                Type of Problem he/she is facing
              </label>
              <Textarea
                placeholder="Allergies, Colds and Flu, Headaches..etc"
                name="TypeOfProblemHeSheIsFacing"
                value={this.state.TypeOfProblemHeSheIsFacing}
                onChange={(e) => this.aptchange(e)}
              />
              <div className={styles.errors}>
                {this.state.TypeOfProblemHeSheIsFacingError}
              </div>

              <label className={styles.ptdiagnosed}>
                Have they been diagnosed with this problem before.(Optional)
              </label>
              <div className={styles.ptYesNo}>
                <>
                  <input
                    type="radio"
                    name="HaveTheyBeenDiagnosedWithThisProblemBefore"
                    id="Yes"
                    className={styles.yesCheck}
                    value="Yes"
                    onChange={(e) => this.aptchange(e)}
                  />
                  <label>Yes</label>
                </>
                <>
                  <input
                    type="radio"
                    name="HaveTheyBeenDiagnosedWithThisProblemBefore"
                    id="No"
                    className={styles.yesCheck}
                    value="No"
                    onChange={(e) => this.aptchange(e)}
                  />
                  <label>No</label>
                </>
              </div>
              <div className={styles.errors}>
                {this.state.HaveTheyBeenDiagnosedWithThisProblemBeforeError}
              </div>
              <label className={styles.ptMedic}>
                Medications Used (Optional):
              </label>
              <Textarea
                type="text"
                name="MedicationsUsed"
                value={this.state.MedicationsUsed}
                onChange={(e) => this.aptchange(e)}
              />
              <div className={styles.errors}>
                {this.state.MedicationsUsedError}
              </div>

              <label className={styles.ptInsurance}>Insurance Type:</label>
              <select
                className={styles.ptInsurancetype}
                name="InsuranceType"
                value={this.state.InsuranceType}
                onChange={(e) => this.aptchange(e)}
              >
                <option value="Select Insurance Type">
                  Select Insurance Type
                </option>
                <option value="Anthem MediBlue Select (HMO)">
                  Anthem MediBlue Select (HMO)
                </option>
                <option value="SCAN Classic (HMO)">SCAN Classic (HMO)</option>
                <option value="WellCare Dividend (HMO)">
                  WellCare Dividend (HMO)
                </option>
              </select>
              <div className={styles.errors}>
                {this.state.InsuranceTypeError}
              </div>
              <label className={styles.ptInsurValid}>Validity:</label>
              <select
                className={styles.ptInsValidity}
                name="InsuranceValidity"
                value={this.state.InsuranceValidity}
                onChange={(e) => this.aptchange(e)}
              >
                <option value="validity">Validity</option>
                <option value="6 months">6 months</option>
                <option value="10 months">10 months</option>
                <option value="12 months">12 months</option>
              </select>
              <div className={styles.errors}>
                {this.state.InsuranceValidityError}
              </div>
              <Button
                onClick={(e) => this.onSubmit(e)}
                buttonName="Submit"
                style={{
                  color: "white",
                  margin: "20px 15px 30px",
                  padding: "10px 10px",
                  width: "90%",
                  maxWidth: "500px",
                }}
              ></Button>
              <ToastContainer />
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default Appointments;
